export default "__VITE_ASSET__CdT6gO9e__"